<div class="center-div">
  <h3>Error - 401</h3>
  <h5>{{error}}</h5>
</div>